import React, { Component } from 'react';
import { connect } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import TableGenerator from '../../../../components/TableGenerator/TableGenerator';
import BreadCrumbs from '../../../../components/Breadcrumbs/Breadcrumbs';
import Spinner from '../../../../components/Spinner/Spinner';
import Backdrop from '../../../../components/Backdrop/Backdrop';
import * as actions from '../../../../store/actions';
import Delete from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import Star from '../../../../assets/imgs/icon-star.svg';
import { withRouter } from 'react-router-dom';
import BootStrapButton from 'react-bootstrap/Button';
import formatPhoneNumber from '../../../../utilities/formatPhoneNumber';

class ListUsers extends Component {
  componentDidMount() {
    this.props.listUsers();
  }
  isUK = () => process.env.REACT_APP_STAGE === 'uk';

  getBreadcrumbs = () => {
    let label = 'System Users';
    if (this.props.role && this.props.role === 'district_champion') {
      label = `${this.isUK() ? 'Group' : 'Organization'} Champions`;
    }

    if (this.props.role && this.props.role === 'school_champion') {
      label = `${this.isUK() ? 'Organisation' : 'Group'} Champions`;
    }
    const breadcrumbs = [
      {
        key: 1,
        url: '/admin/',
        label: 'Home',
      },
      {
        key: 2,
        url: '/admin/survey/list',
        label: label,
      },
    ];

    return breadcrumbs;
  };

  generateTableData = () => {
    const isCleverOrg = this.props.organization && !!this.props.organization.cleverData;
    if (this.props.users && this.props.users.length > 0) {
      const result = this.props.users.map(item => {
        return {
          star: item.isDesignated === '1' ? <img src={`${Star}`} alt="star icon" /> : null,
          name: item.firstName || item.lastName ? <span>{`${item.firstName || ''} ${item.lastName || ''}`}</span> : '',
          email: item.email,
          phoneNumber: formatPhoneNumber(item.phoneNumber),
          ...(isCleverOrg && { activated: (item.cleverData ? item.isActivated : true) ? <CheckIcon className="blue-fill-icon" /> : null }),
          icon: (
            <>
              {this.props.realRole === 'school_champion' ||
              this.props.realRole === 'district_champion' ||
              (this.props.realRole === 'tm_admin' && this.props.role === 'tm_admin') ||
              (this.props.realRole === 'tm_admin' && this.props.organization && this.props.organization.isTMAllowed === true) ||
              (this.props.realRole === 'tm_admin' && this.props.organization.parentOrg && this.props.organization.parentOrg.isTMAllowed === true) ? (
                <>
                  <Edit className="blue-fill-icon" onClick={() => this.openUpdateUserModal(item)} />
                  <Delete className="blue-fill-icon" onClick={() => this.openDeleteUserConfirmationModal(item)} />{' '}
                </>
              ) : null}
            </>
          ),
        };
      });

      return result;
    }

    return [];
  };

  openDeleteUserConfirmationModal = user => {
    let firstName = user.firstName ? user.firstName : '';
    let lastName = user.lastName ? user.lastName : '';
    this.props.openModal({
      modalType: 'GENERIC_MODAL',
      show: true,
      headline: 'Are you sure?',
      content: (
        <div>
          <p>
            You are attempting to delete user “
            <strong>
              {`${firstName}`} {`${lastName}`}
            </strong>
            ”. Are you sure you want to continue? You cannot undo this action.{' '}
          </p>
          <BootStrapButton type="button" className="small-button green" size="lg" onClick={() => this.props.deleteUser(user.username)}>
            Delete user
          </BootStrapButton>
          <BootStrapButton type="button" className="small-blue-button-outlined" size="lg" onClick={this.props.closeModal}>
            Cancel
          </BootStrapButton>
        </div>
      ),
    });
  };

  openAddUserModal = () => {
    this.props.openModal({
      modalType: 'ADD_USER_MODAL',
      show: true,
      addUser: this.props.createUser,
      closeModal: e => this.closeModal(e),
    });
  };

  openUpdateUserModal = user => {
    this.props.openModal({
      modalType: 'ADD_USER_MODAL',
      show: true,
      addUser: this.props.updateUser,
      listUsers: this.props.listUsers,
      user,
      closeModal: e => this.closeModal(e),
    });
  };

  closeModal = e => {
    // Prevent the form from submitting
    if (e) {
      e.preventDefault();
    }

    this.props.closeModal();
  };

  render() {
    let createButtonText = 'Create User';
    let alertText = `You are currently the only ${this.isUK() ? 'MyMynd' : 'Terrace Metrics'} Admin user. Create new ${
      this.isUK() ? 'MyMynd' : 'Terrace'
    } Admin system users by clicking on the button above or edit your information below.`;

    if (this.props.role && this.props.role === 'district_champion') {
      createButtonText = `Create ${this.isUK() ? 'Group' : 'Organization'} Champion`;
      alertText = `You are currently the only ${this.isUK() ? 'Group' : 'Organization'} Champion for the ${(this.props.organization && this.props.organization.name) || ''}. Add new ${
        this.isUK() ? 'Group' : 'Organization'
      } Champions with the button above or edit your information below.`;
    }

    if (this.props.role && this.props.role === 'school_champion') {
      createButtonText = `Create ${this.isUK() ? 'Organisation' : 'Group'} Champion`;
      alertText = `You are currently the only ${this.isUK() ? 'Organisation' : 'Group'} Champion for ${(this.props.organization && this.props.organization.name) || ''}. Add new ${
        this.isUK() ? 'Organisation' : 'Group'
      } Champions with the button above or edit your information below.`;
    }
    const isCleverOrg = this.props.organization && this.props.organization.cleverData;
    return (
      <>
        <div className="sub-header">
          <BreadCrumbs breadcrumbs={this.getBreadcrumbs()} />
          <BootStrapButton type="submit" className="small-button green" size="lg" variant="success" onClick={this.openAddUserModal}>
            {createButtonText}
          </BootStrapButton>
        </div>
        {!this.props.isUsersLoaded ? (
          <>
            <Backdrop>
              <Spinner />
            </Backdrop>
          </>
        ) : (
          <>
            {this.props.users && this.props.users.length < 2 ? (
              <Alert className="alert" dismissible variant="info">
                <div className="alertHeader">You’re the first one here.</div>
                <div>{alertText}</div>
              </Alert>
            ) : null}
            <div className={this.props.users.length > 0 ? null : 'hidden'}>
              <TableGenerator
                config={{
                  headers:
                    this.props.realRole === 'school_champion' ||
                    this.props.realRole === 'district_champion' ||
                    (this.props.realRole === 'tm_admin' && this.props.role === 'tm_admin') ||
                    (this.props.realRole === 'tm_admin' && this.props.role === 'district_champion' && this.props.organization && this.props.organization.isTMAllowed !== false) ||
                    (this.props.role === 'school_champion' && this.props.organization.parentOrg.isTMAllowed !== false)
                      ? isCleverOrg
                        ? ['', 'NAME', 'EMAIL', 'PHONE', 'ACTIVATED', '']
                        : ['', 'NAME', 'EMAIL', 'PHONE', '']
                      : isCleverOrg
                      ? ['', 'NAME', 'EMAIL', 'PHONE', 'ACTIVATED', '']
                      : ['', 'NAME', 'EMAIL', 'PHONE'],
                  contentRows: this.generateTableData(),
                }}
              />
            </div>
            <>
              {this.props.role && this.props.role === 'district_champion' ? (
                <p className="ml-3 caption">
                  <img src={Star} alt="star icon" style={{ marginRight: '1rem' }} />
                  <span className="align-middle">
                    Denotes designated {this.isUK() ? 'Group' : 'Organization'} Champion. The designated {this.isUK() ? 'Group' : 'Organization'} Champion will be the main point of contact for{' '}
                    {this.isUK() ? 'MyMynd' : 'Terrace Metrics'}.
                  </span>
                </p>
              ) : null}
            </>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    users: state.users.users,
    isUsersLoaded: state.users.isLoaded,
    organization: state.organizations.organization,
    role: state.auth.role,
    realRole: state.auth.realRole,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: modalProps => dispatch(actions.openModal(modalProps)),
    closeModal: () => {
      dispatch(actions.closeModal());
      dispatch(actions.clearUserErrors());
    },
    createUser: userProps => dispatch(actions.createUser(userProps)),
    listUsers: () => dispatch(actions.listUsers()),
    updateUser: (userId, values) => dispatch(actions.updateUser(userId, values)),
    deleteUser: userId => dispatch(actions.deleteUser(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListUsers));
